import React, { Fragment } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton, Divider } from 'foundations-library/components'

const useStyles = makeStyles((theme) => {
    const { colors } = theme['foundations-library']

    return {
        root: {
            width: '100%',
            '& .tabs': {
                backgroundColor: colors.neutral[50],
                width: '100%',
                display: 'flex',
                padding: '3px',
                borderRadius: '25px',
                '& .active-tab': {
                    backgroundColor: '#000 !important',
                    width: '50%',
                    height: '44px',
                    borderRadius: '30px',
                    opacity: 1
                }
            }
        },
        contentRoot: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            '& .item': {
                display: 'flex',
                padding: '20px',
                alignSelf: 'stretch',
                alignItems: 'flex-start',
                flexDirection: 'column',
                gap: '29px',
                '& .summary': {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    alignSelf: 'stretch',
                    gap: '10px',
                    '& .header-skeleton': {
                        backgroundColor: `${colors.neutral[900]}!important`
                    },
                    '& .content-skeleton': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        alignSelf: 'stretch',
                        gap: '10px'
                    }
                }
            }
        }
    }
})

/**
 * Skeleton loader for the Call Details Tabs section.
 *
 * Displays placeholder skeletons for tabs and content while data is loading.
 * @component
 * @example
 * return <CallDetailsTabsSkeleton />
 */
const CallDetailsTabsSkeleton = () => {
    const classes = useStyles()

    const renderTabs = () => {
        return (
            <div className={'tabs'}>
                <Skeleton animation={'wave'} className={'active-tab'} variant='rect' height='40px' width='100px' />
            </div>
        )
    }

    const renderContent = () => {
        const array = [0, 1, 2]
        return (
            <div className={classes.contentRoot}>
                {array.map((i) => {
                    return (
                        <Fragment key={i}>
                            <div className={'item'}>
                                <div className={'summary'}>
                                    <Skeleton animation={'wave'} className={'header-skeleton'} variant='text' width={100} />
                                    <div className={'content-skeleton'}>
                                        <Skeleton variant='text' />
                                        <Skeleton variant='text' />
                                        <Skeleton variant='text' />
                                        <Skeleton variant='text' />
                                    </div>
                                </div>
                            </div>
                            {i !== (array.length - 1) && <Divider marginTop={0} marginBottom={0} />}
                        </Fragment>
                    )
                })}
            </div>
        )
    }

    return (
        <div className={classes.root}>
            {renderTabs()}
            {renderContent()}
        </div>
    )
}

export default CallDetailsTabsSkeleton
